import './MobileShowMore.css'
import {MouseEventHandler} from "react";
import blueArrow from '../../imgs/blue_arrow.png'

interface MobileShowMoreProps {
    title: string,
    onClick: MouseEventHandler<HTMLAnchorElement>
}

export default function MobileShowMore(props: MobileShowMoreProps) {
    let {title, onClick} = props;
    return <a className="Mobile_show_more" onClick={onClick}>
        <div className="Mobile_show_more__title">{title}</div>
        <img src={blueArrow} className="Mobile_show_more__image"/>
    </a>
}